"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CorporatePricingEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultPlans = [
    { name: "Starter", price: "49", period: "/mo", desc: "For small teams", features: ["5 Users", "Basic Analytics", "Standard Support"], buttonText: "Choose Starter", link: "#" },
    { name: "Enterprise", price: "299", period: "/mo", desc: "For large companies", features: ["Unlimited Users", "Advanced Security", "24/7 Phone Support"], buttonText: "Choose Enterprise", link: "#" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Flexible Pricing Plans"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Pricing Plans</h4>
            <ListItemEditor
              label="Plans"
              items={content.plans || defaultPlans}
              itemSchema={[
                { key: "name", label: "Plan Name", type: "text" },
                { key: "price", label: "Price ($)", type: "text" },
                { key: "period", label: "Period (e.g. /mo)", type: "text" },
                { key: "desc", label: "Description", type: "text" },
                { key: "buttonText", label: "Button Label", type: "text" },
                { key: "link", label: "Button Link", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, plans: items })}
              addItemText="Add Plan"
            />
          </div>
        </div>
      }
    />
  );
}
